import React from "react";

const OcularExamination = () => {
  let leftEye = (
    <svg
      width="223"
      height="93"
      viewBox="0 0 223 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M111.343 92C141.634 92 169.103 87.0051 189.037 78.8925C199.001 74.8372 207.131 69.9832 212.786 64.542C218.444 59.0982 221.686 53.0012 221.686 46.5C221.686 39.9988 218.444 33.9018 212.786 28.458C207.131 23.0168 199.001 18.1628 189.037 14.1075C169.103 5.99489 141.634 1 111.343 1C81.0522 1 53.5827 5.99489 33.6488 14.1075C23.6844 18.1628 15.5543 23.0168 9.89935 28.458C4.24165 33.9018 1 39.9988 1 46.5C1 53.0012 4.24165 59.0982 9.89935 64.542C15.5543 69.9832 23.6844 74.8372 33.6488 78.8925C53.5827 87.0051 81.0522 92 111.343 92Z"
        fill="white"
        stroke="black"
        stroke-width="2"
      />
      <circle cx="111.979" cy="47.1358" r="20.9786" fill="#212529" />
      <circle cx="207.972" cy="46.4999" r="12.7143" fill="#212529" />
      <circle cx="111.343" cy="46.5" r="45.5" stroke="black" stroke-width="2" />
    </svg>
  );
  let rightEye = (
    <svg
      width="223"
      height="93"
      viewBox="0 0 223 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M111.343 92C81.052 92 53.5825 87.0051 33.6487 78.8925C23.6842 74.8372 15.5541 69.9832 9.89919 64.542C4.24147 59.0982 0.999832 53.0012 0.999832 46.5C0.999832 39.9988 4.24147 33.9018 9.89919 28.458C15.5541 23.0168 23.6842 18.1628 33.6487 14.1075C53.5825 5.99489 81.052 1 111.343 1C141.633 1 169.103 5.99489 189.037 14.1075C199.001 18.1628 207.131 23.0168 212.786 28.458C218.444 33.9018 221.686 39.9988 221.686 46.5C221.686 53.0012 218.444 59.0982 212.786 64.542C207.131 69.9832 199.001 74.8372 189.037 78.8925C169.103 87.0051 141.633 92 111.343 92Z"
        fill="white"
        stroke="black"
        stroke-width="2"
      />
      <circle
        cx="20.9786"
        cy="20.9786"
        r="20.9786"
        transform="matrix(-1 0 0 1 131.686 26.1572)"
        fill="#212529"
      />
      <circle
        cx="12.7143"
        cy="12.7143"
        r="12.7143"
        transform="matrix(-1 0 0 1 27.4282 33.7856)"
        fill="#212529"
      />
      <circle
        cx="44.5"
        cy="44.5"
        r="45.5"
        transform="matrix(-1 0 0 1 155.843 2)"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  );
  let rightLens = (
    <svg
      width="127"
      height="127"
      viewBox="0 0 127 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="63.5"
        cy="63.5"
        r="62.5"
        fill="white"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  );
  let leftLens = (
    <svg
      width="127"
      height="127"
      viewBox="0 0 127 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="63.5"
        cy="63.5"
        r="62.5"
        fill="white"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  );
  let leftFundus = (
    <svg
      width="132"
      height="132"
      viewBox="0 0 132 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="66"
        cy="66"
        r="65"
        fill="white"
        stroke="black"
        stroke-width="2"
      />
      <circle cx="90" cy="66" r="17" stroke="black" stroke-width="2" />
    </svg>
  );
  let rightFundus = (
    <svg
      width="132"
      height="132"
      viewBox="0 0 132 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="66"
        cy="66"
        r="65"
        fill="white"
        stroke="black"
        stroke-width="2"
      />
      <circle cx="44" cy="69" r="17" stroke="black" stroke-width="2" />
    </svg>
  );
  let nextIcon = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#0D46C1" fill-opacity="0.2" />
      <path
        d="M7.08317 12.5002C7.08317 12.1262 7.38631 11.8231 7.76025 11.8231H15.3097L12.009 8.52238C11.7392 8.2526 11.7431 7.81403 12.0175 7.54906C12.2853 7.29062 12.7107 7.29437 12.9738 7.5575L17.8629 12.4465C17.8925 12.4762 17.8925 12.5242 17.8629 12.5538L12.9748 17.4418C12.7125 17.7042 12.2872 17.7041 12.0248 17.4418C11.7634 17.1803 11.7624 16.7566 12.0227 16.494L15.3097 13.1772H7.76025C7.38631 13.1772 7.08317 12.8741 7.08317 12.5002Z"
        fill="#4C004A"
      />
    </svg>
  );
  return (
    <>
      <div className="grid grid-cols-4 gap-5 p-5">
        <h1 className="col-span-2 text-center text-xl font-bold">Right Eye</h1>
        <h1 className="col-span-2 text-center text-xl font-bold">Left Eye</h1>
        <div className="col-span-4"></div>
        {/* row 1 */}
        <div>
          <p>Lids</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Lashes</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>

        <div className="border-l-2 pl-9">
          <p>Lids</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Lashes</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>

        {/* row 1 */}
        <div>
          <p>Conjectiva</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Sclara</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div className="border-l-2 pl-9">
          <p>Conjectiva</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Sclara</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>

        {/* row 1 */}
        <div>
          <p>Cornea</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Ant.cha</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div className="border-l-2 pl-9">
          <p>Cornea</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Ant.cha</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>

        {/* row 1 */}
        <div>
          <p>Iris</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Pupil</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div className="border-l-2 pl-9">
          <p>Iris</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Pupil</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>

        {/* row 1 */}
        <div>
          <p>Lens</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Pos.cha</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div className="border-l-2 pl-9">
          <p>Lens</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Pos.cha</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>

        {/* row 1 */}
        <div>
          <p>CD Ratio</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>NRR</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div className="border-l-2 pl-9">
          <p>CD Ratio</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>NRR</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        {/* row 1 */}
        <div>
          <p>Macular</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>AV</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div className="border-l-2 pl-9">
          <p>Macular</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>AV</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>

        {/* row 1 */}
        <div>
          <p>Peripheri</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div></div>
        <div className="border-l-2 pl-9">
          <p>Peripheri</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div></div>
        {/* next row for buttons */}
        <div className="col-span-2 text-center my-10">
          <button
            type="button"
            className="bg-blue-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 border border-blue-500 text-blue-500"
          >
            All Clear and Healthy
          </button>
        </div>
        {/* next row for buttons */}
        <div className="col-span-2 text-center my-10 border-l-2">
          <button
            type="button"
            className="bg-blue-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 border border-blue-500 text-blue-500"
          >
            All Clear and Healthy
          </button>
        </div>
        {/* next for eyes */}
        <p className="col-span-2">Eye</p>
        <p className="col-span-2 border-l-2">Eye</p>
        {/* left eye */}
        <div className="col-span-2 bg-gray-100 p-4 flex justify-evenly">
          {/* eye and text */}
          <div>
            {leftEye}
            <br />
            <p className="ml-14">Draw on the eye</p>
          </div>
          {/* a verticle line */}
          <div className="border border-l-gray-400"></div>
          {/* text:Note */}
          <p>Note</p>
        </div>
        {/* right eye */}
        <div className="col-span-2 bg-gray-100 p-4 flex justify-evenly">
          {/* eye and text */}
          <div>
            {rightEye}
            <br />
            <p className="ml-14">Draw on the eye</p>
          </div>
          {/* a verticle line */}
          <div className="border border-l-gray-400"></div>
          {/* text:Note */}
          <p>Note</p>
        </div>

        {/* next for Lens */}
        <p className="col-span-2">Lens</p>
        <p className="col-span-2 border-l-2">Lens</p>
        {/* left eye */}
        <div className="col-span-2 bg-gray-100 p-4 flex justify-evenly">
          {/* eye and text */}
          <div>
            {leftLens}
            <br />
            <p className="ml-14">Draw on the lens</p>
          </div>
          {/* a verticle line */}
          <div className="border border-l-gray-400"></div>
          {/* text:Note */}
          <p>Note</p>
        </div>
        {/* right eye */}
        <div className="col-span-2 bg-gray-100 p-4 flex justify-evenly">
          {/* eye and text */}
          <div>
            {rightLens}
            <br />
            <p className="ml-14">Draw on the lens</p>
          </div>
          {/* a verticle line */}
          <div className="border border-l-gray-400"></div>
          {/* text:Note */}
          <p>Note</p>
        </div>

        {/* next for Fundus */}
        <p className="col-span-2">Fundus</p>
        <p className="col-span-2 border-l-2">Fundus</p>
        {/* left eye */}
        <div className="col-span-2 bg-gray-100 p-4 flex justify-evenly">
          {/* eye and text */}
          <div>
            {leftFundus}
            <br />
            <p className="ml-14">Draw on the fundus</p>
          </div>
          {/* a verticle line */}
          <div className="border border-l-gray-400"></div>
          {/* text:Note */}
          <p>Note</p>
        </div>
        {/* right eye */}
        <div className="col-span-2 bg-gray-100 p-4 flex justify-evenly">
          {/* eye and text */}
          <div>
            {rightFundus}
            <br />
            <p className="ml-14">Draw on the fundus</p>
          </div>
          {/* a verticle line */}
          <div className="border border-l-gray-400"></div>
          {/* text:Note */}
          <p>Note</p>
        </div>
        <div className="col-span-4">
          <p>Ophthalmoscopy Notes:</p>
          <br />
          <textarea
            className="w-full bg-gray-100"
            rows={10}
            placeholder="Type Here"
          ></textarea>
        </div>
        {/* save and contine button */}
        <div className="text-right my-5 ml-3 col-span-4">
          <button
            type="button"
            className="bg-blue-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 border border-blue-500 text-blue-500"
          >
            {nextIcon} &nbsp;&nbsp; Save And Continue
          </button>
        </div>
        {/* last card */}
        <div className="col-span-4">
          <div className="bg-blue-100 p-5 shadow-md rounded-md">
            <p>Ocular Health Examination Methods</p>
          </div>
          <div className="flex justify-between w-[90%] m-auto p-4">
            <div>
              <input id="checkbox1" type="checkbox" />
              &nbsp;&nbsp;
              <label htmlFor="checkbox1">Slit Lamp</label>
            </div>

            <div>
              <input id="checkbox2" type="checkbox" />
              &nbsp;&nbsp;
              <label htmlFor="checkbox2">Direct Ophthalmoscope</label>
            </div>

            <div>
              <input id="checkbox3" type="checkbox" />
              &nbsp;&nbsp;
              <label htmlFor="checkbox3">OCT</label>
            </div>
          </div>
          <div className="flex justify-between w-[90%] m-auto p-4">
            <div>
              <input id="checkbox4" type="checkbox" />
              &nbsp;&nbsp;
              <label htmlFor="checkbox4">Volk</label>
            </div>

            <div>
              <input id="checkbox5" type="checkbox" />
              &nbsp;&nbsp;
              <label htmlFor="checkbox5">Fundus Imaging</label>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OcularExamination;
